// src/components/ServicesSection.js
import React from 'react';
import './ServicesSection.css';
import ServiceCard from './ServiceCard';

// Import your icons from src/assets
import woundCareIcon from '../assets/wound-care-icon.png';
import vomitingIcon from '../assets/vomiting-icon.png';
import limpingIcon from '../assets/limping-icon.png';
import skinIssueIcon from '../assets/skin-issues-icon.png'
import dewormingIcon from '../assets/deworming-icon.png'
import inappetence from '../assets/inappetence.png'
import vaccinationIcon from '../assets/vaccination.png'
import hairfall from '../assets/hairfall.png'
// ... import all other service icons

const services = [
  { icon: woundCareIcon, title: 'WOUND CARE', description: 'Healing for cuts and injuries' },
  { icon: vomitingIcon, title: 'VOMITING & FEVER', description: 'Treats Sudden Sickness' },
  { icon: limpingIcon, title: 'LIMPING', description: 'Care for leg or joint pain' },
  { icon: skinIssueIcon, title: 'SKIN ISSUES & ALLERGY', description: 'Relief from Itching & Rashes' },
  { icon: dewormingIcon, title: 'DEWORMING & TICKS', description: 'Eliminates internal parasites' },
  { icon: inappetence, title: 'NOT EATING FOOD', description: 'Support for poor appetite' },
  { icon: vaccinationIcon, title: 'YEARLY VACCINATION', description: 'Prevents deadly diseases' },
  { icon: hairfall, title: 'HAIRFALL', description: 'Control for shedding' },
];

const ServicesSection = () => {
  return (
    <section className="services-section container">
      <h2 className="section-title">Care We Provide at Home <span className='title-highlight'><br />@ Rs<span className='dot'>.</span> 599</span></h2>
      <div className="services-grid">
        {services.map((service, index) => (
          <ServiceCard 
            key={index}
            icon={service.icon}
            title={service.title}
            // description={service.description}
          />
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;